module.exports = __webpack_public_path__ + "img/metal-black-frame-right-shadowed.5eee404c.png";